export default __webpack_public_path__ + "static/media/git.f37c5d0b.png";